import { render } from "./NotificationsComponent.vue?vue&type=template&id=08dbb558&scoped=true"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js"

import "./NotificationsComponent.vue?vue&type=style&index=0&id=08dbb558&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08dbb558"]])

export default __exports__